<template>
    <div class="grey-body">
        <div class="box1200 margin-bottom-20">
            <public-header></public-header>
             <div class="height70"></div>
            <div class="white-bg margin-top-20 margin-bottom-40 padding30 radius">
                <div class="about">
                    <h3 class="title">{{this.$store.state.siteName}}是什么？</h3>
                    <p>{{this.$store.state.siteName}}是一个基于本地微信生态、熟人社交关系的共享个人流量的同城营销推广服务平台。</p>
                    <p>聚合本地企业商家和个人流量资源，一则为企业用户提供高供性价比、高转化率、高精准覆盖的同城即时推广服务，帮助企业快速找到、找对、用对达人推广资源；二则为达人用户提供即时对接同城企业商家的推广任务订单，随时随地轻松接单转发赚钱，实现个人流量变现。</p>
                    <p>{{this.$store.state.siteName}}，推广本该如此精准！</p>
                </div>
                <h3 class="title margin-top-20">联系我们</h3>
                <div class="contact flex">
                    <div class="contact-text">
                        <p>梅州市艺博网络科技有限公司（小城达人）</p>
                        <p>地址：广东省梅州市梅江区创杰金融中心10楼</p>
                        <p>电话：0753-2354999</p>
                        <p>手机：19128188497</p>
                        <p>邮箱：join@xiaochengdaren.com</p>
                    </div>
                    <div class="map"><img src="@/assets/images/map.jpg"></div>
                </div>
            </div>
        </div>
        <public-footer></public-footer>
        <back-top></back-top>
    </div>
</template>
<script>
    import PublicHeader from '@/components/PublicHeader.vue'
    import PublicFooter from '@/components/PublicFooter'
    import BackTop from '@/components/BackTop'
    export default {
        name: 'About',
        components: {
            PublicHeader,
            PublicFooter,
            BackTop
        }
    }
</script>
<style scoped>
    .about{font-size: 14px;line-height: 36px;margin-bottom:20px;}
    .title{font-size:18px; font-weight:normal;border-left:3px #FF741F solid;display: inline;padding-left:10px;}
    .about p{padding:3px 0;}
    .contact{margin-top:10px;}
    .contact p{font-size:14px;line-height:36px;}
    .contact .map{margin-left:40px;}
</style>
